import React, { useContext } from 'react';
import Style from './Navbar.module.scss';
import Toggler from "./home/Toggler";
import { useLocation } from "react-router-dom";
import { HashLink as Link } from 'react-router-hash-link';
import { Box } from "@mui/material";
import { useInfo, singlePage } from "../info/Info";
import { LanguageContext } from '../context/LanguageContext';

// This function is used to create a scroll offset to compensate for the navbar
// when you click on the nav buttons to scroll down.
const scrollWidthOffset = (el) => {
    const yCoordinate = el.getBoundingClientRect().top + window.pageYOffset;
    const yOffset = -80; 
    window.scrollTo({ top: yCoordinate + yOffset, behavior: 'smooth' }); 
}

export default function Navbar({ darkMode, handleClick, active, setActive }) {
    const info = useInfo();
    const { language, toggleLanguage } = useContext(LanguageContext);

    const links = [
        {
            name: language === 'pt' ? 'Início' : 'Home',
            to: '',
            active: 'home'
        },
        {
            name: language === 'pt' ? 'Sobre Mim' : 'About Me',
            to: 'about',
            active: 'about'
        },
        {
            name: info.initials,
            type: 'initials',
            to: '',
            active: 'home'
        },
        {
            name: language === 'pt' ? 'Portfólio' : 'Portfolio',
            to: 'portfolio',
            active: 'portfolio'
        }
    ];

    return (
        <Box component={'nav'} width={'100%'} position={singlePage ? 'fixed' : 'relative'} className={darkMode? Style.dark : Style.light}>
            <Box component={'ul'} display={'flex'} justifyContent={'center'} alignItems={'center'}
                gap={{ xs: '1rem', sm: '2rem', md: '8rem' }} flexWrap={'wrap'} px={{xs: 2, sm: 0}} py={{xs: 1, sm: 0}}
                textTransform={'lowercase'} fontSize={{xs: '0.85rem', sm: '1rem'}}>
                {links.map((link, index) => (
                    <Box key={index} component={'li'} className={(link.active === active && !link.type) && Style.active}
                        sx={{ borderImageSource: info.gradient }}>
                        <Link to={singlePage ? `#${link.to}` : `/${link.to}`}
                        scroll={el => scrollWidthOffset(el)}
                            smooth
                            onClick={() => setActive(link.active)} className={Style.link}>
                            {!link.type && <p style={{ padding: '0.5rem 0' }}>{link.name}</p>}
                            {link.type && <h1>{link.name}</h1>}
                        </Link>
                    </Box>
                ))}
                {info.resume && (
                    <Box component={'li'} className={(active === 'curriculum') ? Style.active : ''} sx={{ borderImageSource: info.gradient }}>
                        <Link to={singlePage ? `#curriculum` : `/curriculum`}
                            scroll={el => scrollWidthOffset(el)}
                            smooth
                            onClick={() => setActive('curriculum')} className={Style.link}>
                            <p style={{ padding: '0.5rem 0' }}>{language === 'pt' ? 'currículo' : 'resume'}</p>
                        </Link>
                    </Box>
                )}
                <li style={{ cursor: 'pointer', fontSize: '1.2rem', padding: '0 0.5rem' }} 
                    onClick={() => toggleLanguage(language === 'pt' ? 'en' : 'pt')}
                    title={language === 'pt' ? 'Mudar para Inglês' : 'Switch to Portuguese'}
                >
                    {language === 'pt' ? '🇵🇹' : '🇺🇸'}
                </li>
                <li>
                    <Toggler darkMode={darkMode} handleClick={handleClick} />
                </li>
            </Box>
        </Box>
    )
}